import * as XLSX from "xlsx";

export const exportRowsToWorkbook = (fileName: string, sheetName: string, rows: Array<Array<string | number>>) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
